import styled from '@emotion/styled'

import { pageBackground } from '../../../components/pageBackground'
import breakpoints from '../../../guided-toolbox/utils/breakpoints'

// Fill the viewport without scrolling the outer layout. StepScroll handles
// scrolling between the fixed-size nav and footer.
export const AdviceLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh; /* fallback for browsers without dynamic viewport units */
  height: 100dvh;
  overflow: hidden;
  /* Shared with the docked Hey Nic panel's footer, which has to line its own fill
     up with this exact layer (see pageBackgroundFixed). */
  ${pageBackground}

  /* The mobile design uses a plain background without the diamond texture. */
  @media (max-width: 600px) {
    background-image: none;
  }
`

// The scrollable region between the nav and footer. `min-height: 0` allows this
// flex child to shrink and scroll instead of pushing the footer off-screen.
export const StepScroll = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 24px 20px 40px;

  /* Add extra side padding on tablets so the row labels do not touch the screen edges. */
  @media (min-width: ${breakpoints.xs + 1}px) and (max-width: ${breakpoints.lgTablet}px) {
    padding-left: 40px;
    padding-right: 40px;
  }
`

// Positioned wrapper that ends at the footer's top edge, so the floating
// scroll-to-bottom button can anchor to the step column rather than the viewport
// — the Hey Nic side panel takes a slice of the viewport, and a viewport-centered
// button would sit off-center over the step content.
export const StepScrollArea = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1000px;
`

// Desktop summary action shown in the center of the top nav. Mobile renders the
// same action within the summary content.
export const WalkMeThroughLink = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 16px;
  color: ${p => p.theme.mediumGray};
  text-decoration: underline;
`
